export const locales = ['en', 'zh-CN', 'de', 'ko'] as const

export type AppLocale = (typeof locales)[number]

export const defaultLocale: AppLocale = 'en'
export const localeCookieName = 'NEXT_LOCALE'

export const localeLabels: Record<AppLocale, string> = {
  en: 'English',
  'zh-CN': '简体中文',
  de: 'Deutsch',
  ko: '한국어',
}

export function isAppLocale(locale: string): locale is AppLocale {
  return locales.includes(locale as AppLocale)
}

export function normalizeAppLocale(locale: string): AppLocale | null {
  const normalized = locale.trim().replace('_', '-').toLowerCase()
  if (!normalized) return null

  if (normalized === 'zh-cn' || normalized.startsWith('zh-hans') || normalized === 'zh') {
    return 'zh-CN'
  }

  const language = normalized.split('-')[0]
  if (isAppLocale(language)) return language

  return null
}

export function resolveLocaleFromAcceptLanguage(acceptLanguage: string | null): AppLocale {
  if (!acceptLanguage) return defaultLocale

  const preferredLocales = acceptLanguage
    .split(',')
    .map((entry, index) => {
      const [locale, ...params] = entry.trim().split(';')
      const qParam = params.find((param) => param.trim().startsWith('q='))
      const q = qParam ? Number(qParam.trim().slice(2)) : 1
      return { locale, q: Number.isFinite(q) ? q : 0, index }
    })
    .sort((a, b) => b.q - a.q || a.index - b.index)

  for (const { locale, q } of preferredLocales) {
    if (q <= 0) continue
    const supportedLocale = normalizeAppLocale(locale)
    if (supportedLocale) return supportedLocale
  }

  return defaultLocale
}
